module.exports = __webpack_public_path__ + "static/media/icon-bind-wx-ani.b15279b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/icon-bind-wx-ani.png
// module id = 646
// module chunks = 1